import React from 'react';
import PropTypes from 'prop-types';
import { Typography } from '@mui/material';
import { useTranslation } from 'react-i18next';

import ValidityAdornment from '../ValidityAdornment';
import { useTheme } from '@mui/material/styles';

const NotifyContentLabel = ({ contentValidity }) => {
  const theme = useTheme();
  const { t } = useTranslation();
  return (
    <div style={{ display: 'flex' }}>
      <Typography
        style={{
          margin: '5px 10px',
          color: contentValidity.contentIsEmpty
            ? theme.palette.error.main
            : theme.palette.text.secondary,
        }}
        variant="subtitle2"
        noWrap
      >
        {t('smartmessaging.contentEditor.notify.content')}
      </Typography>
      <ValidityAdornment
        valid={!contentValidity.contentIsEmpty}
        message={t('smartmessaging.contentEditor.notify.contentIsEmpty')}
      />
    </div>
  );
};

NotifyContentLabel.propTypes = {
  contentValidity: PropTypes.object.isRequired,
};

export default NotifyContentLabel;
